import { render, staticRenderFns } from "./ContactDaeguPage.vue?vue&type=template&id=3ac3536c&scoped=true"
import script from "./ContactDaeguPage.vue?vue&type=script&lang=js"
export * from "./ContactDaeguPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac3536c",
  null
  
)

export default component.exports